import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { Airport } from '../models/airport.model';
import { CloseDialog } from '../../shared/dialog-close/dialog-close';
import { AuthService } from '../../auth/auth/auth.service';
import { UserSubmitNewBusinessComponent } from '../user-submit-new-business/user-submit-new-business.component';

@Component({
  selector: 'app-submit-new-business',
  templateUrl: './submit-new-business.component.html',
  styleUrls: ['./submit-new-business.component.scss']
})
export class SubmitNewBusinessComponent implements OnInit {

  isLoading = false;
  airport: Airport;
  facilityType: string;
  facilityTitleType: string;
  loggedIn = false;

  constructor(private _dialogRef: MatDialogRef<SubmitNewBusinessComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private _matDialog: MatDialog,
              private _auth: AuthService) {
    this.airport = data.airport;
    this.facilityType = data.facilityType;
    this.facilityTitleType = data.facilityType;
    if (data.facilityType === 'business') {
      this.facilityTitleType = 'Business';
    }
  }

  ngOnInit() {
    this._dialogRef.backdropClick().subscribe(() => {
      const CLOSE_DIALOG = new CloseDialog();
      CLOSE_DIALOG.cancelButtonClicked = true;
      this._dialogRef.close(CLOSE_DIALOG);
    });
    if (this._auth.authenticated && this._auth.endUser) {
      this.loggedIn = true;
    }
  }

  async onSubmit() {
    const CLOSE_DIALOG = new CloseDialog();
    const dialogRef = this._matDialog.open(UserSubmitNewBusinessComponent, {
      disableClose: false,
      autoFocus: true,
      data: {
        airport: this.airport,
        facilityType: this.facilityType
      }
    });
    this._dialogRef.close(CLOSE_DIALOG);
  }

}
